import ResultList from "./ResultList";

export default function QuestionResult(props) {
  const {
    question,
    showAnswers,
    hideEnunciado,
    hideAnswers,
    correctSingleAnswers,
    questionNumber,
  } = props;
  const isCorrect = question.checkAnswer(question.answer);

  return (
    <>
      <ResultList
        question={question}
        answer={question.answer}
        isCorrect={isCorrect}
        questionNumber={questionNumber}
        hideEnunciado={hideEnunciado}
        correctSingleAnswers={correctSingleAnswers}
      />
      {showAnswers && !isCorrect && question.answer && !hideAnswers && (
        <>
          <ResultList
            question={question}
            answer={question.correctAnswers}
            isCorrect={true}
            questionNumber={questionNumber}
            hideEnunciado={hideEnunciado}
          />
        </>
      )}
    </>
  );
}
